import React from 'react';
import {
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    FormFeedback,
    Button
} from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormTransports = (props) => {

    const {
            handleInputChange, validaciones, methodAction, name, abbreviation, code,
    } = props;

    const {
        name_valid,
        abbreviation_valid,
        code_valid
    } = validaciones;

    return (
        <Form role="form" onSubmit={methodAction}>
            <div className='form-section'>

                <div style={{ marginBottom: "25px"}}>
                    <h6 style={{ margin: 0, fontWeight: "700", color: "#1f2937" }}>
                        Transporte
                    </h6>

                    <span style={{ fontSize: "12px", color: "#6b7280" }} >
                        Completa la información del transporte
                    </span>
                </div>

                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }} >
                                Nombre del transporte <span style={{ color: "#46AFE5" }}> *</span>
                            </Label>

                            <Input
                                type="text"
                                name="name"
                                onChange={handleInputChange}
                                value={name}
                                autoComplete="off"
                                invalid={name_valid}
                                placeholder="Ej. Transporte refrigerado"
                                style={{
                                    borderRadius: "14px",
                                    minHeight: "40px",
                                    border: "1px solid #dbe4f0",
                                    paddingLeft: "15px",
                                    fontSize: "14px",
                                    boxShadow: "none"
                                }}
                            />

                            <FormFeedback>
                                Mínimo 3 caracteres
                            </FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }} >
                                Abreviación <span style={{ color: "#46AFE5" }}> *</span>
                            </Label>

                            <Input
                                type="text"
                                name="abbreviation"
                                onChange={handleInputChange}
                                value={abbreviation}
                                autoComplete="off"
                                invalid={abbreviation_valid}
                                placeholder="Ej. TR"
                                style={{
                                    borderRadius: "14px",
                                    minHeight: "40px",
                                    border: "1px solid #dbe4f0",
                                    paddingLeft: "15px",
                                    fontSize: "14px",
                                    boxShadow: "none"
                                }}
                            />

                            <FormFeedback>
                                La abreviación debe tener más de un caracter
                            </FormFeedback>
                        </FormGroup>
                    </Col>

                    <Col md="6">
                        <FormGroup>
                            <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }}>
                                Código <span style={{ color: "#46AFE5" }}> *</span>
                            </Label>

                            <Input
                                type="text"
                                name="code"
                                onChange={handleInputChange}
                                value={code}
                                autoComplete="off"
                                invalid={code_valid}
                                placeholder="Ej. 001"
                                style={{ borderRadius: "14px", minHeight: "40px", border: "1px solid #dbe4f0", paddingLeft: "15px", fontSize: "14px",boxShadow: "none"}}
                            />

                            <FormFeedback>
                                El código debe tener más de un caracter
                            </FormFeedback>
                        </FormGroup>
                    </Col>

                </Row>


            </div>

        </Form>
    )
}